import { SortKey } from "./types";

export const TENANT_CONTAMINATION_COLUMNS: {
  key: SortKey;
  label: string;
  align: "left" | "right";
}[] = [
  {
    key: SortKey.NAME,
    label: "contaminationPage:tenantContaminationColumnName",
    align: "left",
  },
  {
    key: SortKey.NR_LOADS,
    label: "contaminationPage:tenantContaminationColumnNrLoads",
    align: "right",
  },
  {
    key: SortKey.CONTAMINATED_WEIGHT,
    label: "contaminationPage:tenantContaminationColumnWeight",
    align: "right",
  },
  {
    key: SortKey.CONTAMINATION_RATE,
    label: "contaminationPage:tenantContaminationColumnRate",
    align: "right",
  },
];

export const MAX_ROWS_COLLAPSED = 5;
